exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-found[data-v-77349ff2]{display:flex;align-items:center;justify-content:center;width:100vw;height:100vh;overflow:hidden;background-color:#dbe8fb}.not-found img[data-v-77349ff2]{width:80%}@media (min-width:1024px){.not-found img[data-v-77349ff2]{width:60%}}@media (min-width:1280px){.not-found img[data-v-77349ff2]{width:50%}}", ""]);

// exports
